import React from "react";
import "./CancellRefundPolicy.css";
import Footer from "./Footer";

const CancellRefundPolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Cancellation and Refund Policy</h1>
        <h2>Eligibility for Refund</h2>
        <p>Refunds are considered only under the following conditions:</p>
        <ul>
          <li>The course was paid for but not accessed or started.</li>
          <li>Duplicate payments made due to technical error.</li>
          <li>Course/service is canceled by the institute.</li>
          <li>Technical issues on our platform that prevent access and are not resolved within a reasonable time.</li>
          <li>We will refund your money within 5-6 Business days. </li>
        </ul>
        <h1>Shipping Policy</h1>
        <h2>📌 Digital Delivery Only</h2>
        <p>All products and services offered on our platform are delivered electronically. Once a student subscribes to a plan, access to the relevant practice test  and get access for typing the document and practice modules is granted immediately.</p>
        
        <h2>🚚 No Physical Shipping</h2>
        
        As we offer only digital content, there is no physical delivery involved. Therefore, no shipping charges apply to any of our plans or products.
        
        <h2>🧾 Order Confirmation</h2>

        <p> An email confirmation will be sent after a successful subscription payment. This email will include details of the plan, duration, and access instructions.</p>
      </div>
      <Footer />
    </div>
  );
};

export default CancellRefundPolicy;
